import React from 'react';
import { useIntl } from 'react-intl';
import { Form, DatePicker as AntDDatePicker } from 'antd';
import { constructValidationRules } from './validations';
import { useLocaleContext } from 'context/LocaleContext';
import moment from 'moment';
import './styles.scss';

const DatePicker: React.FC<any> = ({name, label, validation = {}, defaultValue, className, customRules, validateTrigger, customLayout, ...props}) => {
  const { locale } = useLocaleContext();
  
  const intl = useIntl();
  moment.locale(locale ?? 'en');

  let labelCol: any = {span: 8};
  let wrapperCol: any = {span: 6};

  if (customLayout) {
    if (typeof customLayout === 'object') {
      labelCol = customLayout.labelCol || undefined;
      wrapperCol = customLayout.wrapperCol || undefined;
    } else {
      labelCol = undefined;
      wrapperCol = undefined;
    }
  }

  const normalizeDate = (value: any) => {
    if (!value) return value;
    return moment(value).startOf('day');
  };

  const getValueFromEvent = (value: any) => {
    return normalizeDate(value);
  };

  return (
    <Form.Item
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      name={name}
      label={label}
      rules={customRules ? customRules : constructValidationRules(validation, intl)}
      validateTrigger={validateTrigger}
      getValueFromEvent={getValueFromEvent}
      normalize={normalizeDate}
    >
      <AntDDatePicker
        suffixIcon={<i className='fal fa-calendar-alt' />}
        defaultValue={defaultValue}
        showTime={false}
        {...props}
        className={'default-input-field ' + (className || '')}
      />
    </Form.Item>
  )
}

export default DatePicker;
